import { render } from "./PayerList.vue?vue&type=template&id=3f0a854c&scoped=true"
import script from "./PayerList.vue?vue&type=script&lang=js"
export * from "./PayerList.vue?vue&type=script&lang=js"

import "./PayerList.vue?vue&type=style&index=0&id=3f0a854c&scoped=true&lang=css"

import exportComponent from "/Users/paulestrada/Desktop/PDESTRADA/Contablus/contablusDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f0a854c"]])

export default __exports__